import { ChronoCodeLevel, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { Model } from '../../model/model';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';

/**
 *  Un niveau de chronocode
 *  Permet de normaliser le découpage temporel (saison, semaine, période...)
 */
@entity('wizeoo.allkeyme.core.message.ChronoCodeLevel', 'BU')
export class ChronoCodeLevelVO implements IVo {

  protected _model: Model = null;
  public get model(): Model {
    return this._model as Model;
  }
  public set model(value: Model) {
      this._model = value;
  }
  constructor(model: Model, pSource?: ChronoCodeLevel) {
    this._model = model;
    this._source = pSource ? pSource : new ChronoCodeLevel();
  }
  


  /**
   * Le VO source provenant du back
   */
  private _source: ChronoCodeLevel;

  public get uid(): string {
    return this._source.uid;
  }
  public set uid(uid: string) {
    this._source.uid = uid;
  }

  /**
   * Flag permettant d'indiquer que le chronocode level n'as jamais était persisté en base
   */
  public isFake: boolean = false;

  /** constante de code pour gestion de clés de vision */
  public code: string = 'CHRONO';


  get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.code);
  }

  get source(): ChronoCodeLevel {
    return this._source;
  }

  set source(value: ChronoCodeLevel) {
    this._source = value;
  }

  public get id(): number {
    return this._source.id;
  }

  public set id(value: number) {
    this._source.id = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this._source.label = value;
  }
  public get label(): TranslatedEmb {
    return this._source.label;
  }

  public get level(): number {
    return this._source.level;
  }

  public set level(level: number) {
    this._source.level = level;
  }

  public get businessUnitCode(): string {
    return this._source.businessUnitCode;
  }

  public set businessUnitCode(businessUnitCode: string) {
    this._source.businessUnitCode = businessUnitCode;
  }

  public set domain(domain: string) {
    this._source.domain = domain;
  }

  public get domain(): string {
    return this._source.domain;
  }

  public set parentCode(parentCode: string) {
    this._source.parentCode = parentCode;
  }

  public get parentCode(): string {
    return this._source.parentCode;
  }

  public set timeGapCode(timeGapCode: string) {
    this._source.timeGapCode = timeGapCode;
  }

  public get timeGapCode(): string {
    return this._source.timeGapCode;
  }

  get version(): number {
    return this._source.version;
  }

  set version(value: number) {
    this._source.version = value;
  }

  /**
   * return le label correspondant à la locale si le freedata level a un label, sinon null
   */
  public getEntrieLabel(): string {
    if (this.label && !!this.label?.keys) {
      return this.label.keys[this.model.localeEngine.getLocale()]
        ? this.label.keys[this.model.localeEngine.getLocale()].val
        : Object.values(this.label.keys)[0].val;
    }
    return null;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }
}
